import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="set-content-type"
export default class extends Controller {
  static values = { to: String }

  connect() {
    localStorage.setItem('contentType', this.toValue)
  }
}
